import { suppressBeforeUnloadGuard } from '@hooks/useBeforeUnloadGuard';
import { SECURE_BROWSER_LAUNCH_URL, getSecureBrowserConfigFromFlowDetails, isRunningInSecureBrowser, } from '@utils/secureBrowser';
export function isSecureBrowserRequiredForStep(flowDetails) {
    return Boolean(getSecureBrowserConfigFromFlowDetails(flowDetails));
}
export function ensureSecureBrowser(input) {
    if (isRunningInSecureBrowser()) {
        return true;
    }
    const customToken = input.queryParamsCustomToken || input.customToken || null;
    const resolvedTestInstanceId = String(input.testInstanceId || input.queryParamsTestInstanceId || '');
    const resolvedStepId = String(input.queryParamsStepId || input.stepId || '');
    if (!customToken || !resolvedTestInstanceId || !resolvedStepId) {
        return false;
    }
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('custom_token', customToken);
    currentUrl.searchParams.set('test_instance_id', resolvedTestInstanceId);
    currentUrl.searchParams.set('step_id', resolvedStepId);
    window.history.replaceState(window.history.state, '', `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);
    const launchUrl = `${SECURE_BROWSER_LAUNCH_URL}?redirect_url=${encodeURIComponent(currentUrl.toString())}`;
    suppressBeforeUnloadGuard();
    window.onbeforeunload = null;
    window.location.replace(launchUrl);
    return false;
}
